import type RootStore from "stores/RootStore";
import { RouteType } from "types/RouteType";
import { throwIfFailed } from "shared/dialogSubmit";
import RegistryConnectionsStore from "./RegistryConnectionsStore";

const registryConnectionsRoute: RouteType[] = [
  {
    name: "Registry Connections",
    path: "/infrastructure/registry-connections",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Registry Connections",
        enableRefreshButton: true,
        component: () => import("./RegistryConnections.Header"),
      },
      body: {
        component: () => import("./RegistryConnections.Body"),
        grayBackground: true,
      },
    },
    group: "Infrastructure",
    searchAliases: ["acr", "container registry"],
    // Reads are staff (viewer+); the API enforces the read gate (rbac.ts
    // viewer/operator/admin seam). Connection management (create/edit/validate/
    // remove) governs each registry's encrypted credential and is admin-only —
    // gated in-store via `canManage` (isInfraAdmin) and re-enforced by the API.
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      const store = rootStore.registryConnectionsViewStore as RegistryConnectionsStore;
      store?.loadConnections();
    },
    dialogs: [
      {
        name: "RegistryConnectionFormDialog",
        title: "Registry Connection",
        submitButtonText: "Save connection",
        component: () => import("./dialogs/RegistryConnectionForm.Body"),
        cancelButton: true,
        height: 620,
        onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
          // A refused save throws, so the dialog stays open with the reason in
          // its footer (shared/dialogSubmit).
          const store = rootStore.registryConnectionsViewStore as RegistryConnectionsStore;
          throwIfFailed(await store.saveConnection(), store.formError, "The connection could not be saved.");
        },
        onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
          const store = rootStore.registryConnectionsViewStore as RegistryConnectionsStore;
          return store.isFormValid;
        },
      },
    ],
  },
];

export default registryConnectionsRoute;
